import { ChangeEvent, DataHeader, DataSourceExecutionEvent, LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { getDetentionControlBoolean, LMECompanySettings } from "@mcleod/general";
import { DuplicateId, DuplicateIdProps } from "../../DuplicateId";
import { LocationByTypeProps, LocationByTypeUtil } from "../../LocationByTypeUtil";
import { AutogenLayoutCustomerServiceProfile } from "./autogen/AutogenLayoutCustomerServiceProfile";

const LOCATION_BY_TYPE_PROPS: LocationByTypeProps = { stateType: 'S', zoneType: 'Z', locationType: 'L', useDefault: true }

export class CustomerServiceProfile extends AutogenLayoutCustomerServiceProfile {

    onLoad(): void | Promise<void> {
        this.setProfileColorLayoutToMainDatasource();
        this.validateCustomerProfileRecordExist();

        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOrderIbType, this.textboxOrderIbList, LOCATION_BY_TYPE_PROPS);
        LocationByTypeUtil.setupLocationTypeChangeListener(this.textboxOrderObType, this.textboxOrderObList, LOCATION_BY_TYPE_PROPS);

        const userfilter = (event: any) => event.filter.web_user_type = "U";
        this.textboxOperationsUser.addBeforeLookupModelSearchListener(userfilter);
        this.textboxEntryUser.addBeforeLookupModelSearchListener(userfilter);
        this.textboxOrderTypeId.addBeforeLookupModelSearchListener((event: any) => event.filter.is_active = 'Y');
        this.textboxAuthStatus.visible = getDetentionControlBoolean("is_active", false);

        this.textboxOrderResponsibilityLevel.addLookupModelSelectionListener((event: LookupModelSelectionEvent) => {
            this.clearResponsibilityCodes();
            this.removeBeforeLookupModelSearchListenerToResponsibilityCodes();
            this.createBeforeLookupListenerForResponsibilityCodes();
            this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
        });

        this.onResponsibilityLevelChange();
    }

    public override doAfterDataHeaderSetup(dataHeader: DataHeader): void {
        dataHeader.showDelete = true;
    }

    private validateCustomerProfileRecordExist() {
        const customerServiceProfileUrl = "lme/dispatch/planning/csm/CustomerServiceProfile?mode=update&key=";
        const validateProps: DuplicateIdProps = {tableName: "csm_profile", screenName: "CustomerServiceProfile", navigateToUrl: customerServiceProfileUrl};
        DuplicateId.configureIdTextbox(this.textboxId, validateProps);
    }

    private setProfileColorLayoutToMainDatasource() {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
    }

    sourceCsmProfileAfterExecution(event: DataSourceExecutionEvent) {
        const showMovementType: boolean = LMECompanySettings.get().show_movement_type;
        this.textboxMoveType.visible = showMovementType;
        this.checkboxExcludeMoveType.visible = showMovementType;
    }

    private clearResponsibilityCodes(): void {
        this.textboxResponsibilityCodes.clear();
        this.activeRow?.set("order_resp_codes", null);
    }

    private removeBeforeLookupModelSearchListenerToResponsibilityCodes(): void {
        if (this.orderRespCodesBeforeLookupModelSearchListener) {
            this.textboxResponsibilityCodes.removeBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
        }
    }

    private orderRespCodesBeforeLookupModelSearchListener: (event: LookupModelSearchEvent) => void;

    private createBeforeLookupListenerForResponsibilityCodes() {
        this.orderRespCodesBeforeLookupModelSearchListener = (event) => {
            if (this.activeRow?.isNull("order_resp_level")) {
                event.stop();
                return;
            }
            event.filter.hierarchy_level = this.activeRow?.getNumber("order_resp_level");
        };
        this.textboxResponsibilityCodes.addBeforeLookupModelSearchListener(this.orderRespCodesBeforeLookupModelSearchListener);
    }

    private onResponsibilityLevelChange() {
        this.textboxOrderResponsibilityLevel.addChangeListener((event: ChangeEvent) => {
            const valueResponsibilityLevel = StringUtil.isEmptyString(event.newValue);
            if (valueResponsibilityLevel) {
                this.clearResponsibilityCodes();
                this.mainDataSource.displayDataInBoundComponent(this.textboxResponsibilityCodes);
            }
        });
    }

}
